import { History, StateHistory, initialStateHistory } from "./undoredo.state";
import { UndoRedoActions, UndoRedoActionTypes } from "./undoredo.actions";
import * as utentiActions from '../../utenti/store/utenti.actions';
import * as glossariActions from '../../glossari/store/glossari.actions';

/**
 * Aggiorna lo storico spostando l'ultimo undo come primo redo dopo la sua esecuzione
 * @param state {any}
 */
function undo(state: any): History {
    let latestPast = { ...state.past[state.past.length - 1] }; //ultimo elemento dell'elenco undo, primo a essere ripristinato
    let latestModPast: any;
    if (latestPast.type === utentiActions.UPDATE_USER_V2_SUCCESS || latestPast.type === glossariActions.UPDATE_GLOSSARY_SUCCESS) {
        latestModPast = {
            ...latestPast,
            payload: {
                ...latestPast.payload,
                newValue: latestPast.current
            },
            current: latestPast.payload.newValue
        }
    } else if (latestPast.type === utentiActions.CREATE_USER_SUCCESS || latestPast.type === utentiActions.REMOVE_USER_SUCCESS) {
        latestModPast = {
            ...latestPast,
            type: latestPast.type === utentiActions.CREATE_USER_SUCCESS ? utentiActions.REMOVE_USER_SUCCESS : utentiActions.CREATE_USER_SUCCESS
        }
    } else if (latestPast.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS || latestPast.type === glossariActions.REMOVE_GLOSSARY_SUCCESS) {
        latestModPast = {
            ...latestPast,
            type: latestPast.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS ? glossariActions.REMOVE_GLOSSARY_SUCCESS : glossariActions.ADD_NEW_GLOSSARY_SUCCESS
        }
    }
    const futureWithLatestPast = [latestModPast, ...state.future];
    const pastWithoutLatest = state.past.slice(0, -1);

    return {
        past: [...pastWithoutLatest],
        future: [...futureWithLatestPast]
    };
}

/**
 * Aggiorna lo storico spostando dal futuro al passato un'azione
 * @param state {any}
 */
function redo(state: any): History {
    let latestFuture = { ...state.future[0] };
    let latestModFuture: any;
    if (latestFuture.type === utentiActions.UPDATE_USER_V2_SUCCESS || latestFuture.type === glossariActions.UPDATE_GLOSSARY_SUCCESS) {
        latestModFuture = {
            ...latestFuture,
            payload: {
                ...latestFuture.payload,
                newValue: latestFuture.current
            },
            current: latestFuture.payload.newValue
        }
    } else if (latestFuture.type === utentiActions.CREATE_USER_SUCCESS || latestFuture.type === utentiActions.REMOVE_USER_SUCCESS) {
        latestModFuture = {
            ...latestFuture,
            type: latestFuture.type === utentiActions.CREATE_USER_SUCCESS ? utentiActions.REMOVE_USER_SUCCESS : utentiActions.CREATE_USER_SUCCESS
        }
    } else if (latestFuture.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS || latestFuture.type === glossariActions.REMOVE_GLOSSARY_SUCCESS) {
        latestModFuture = {
            ...latestFuture,
            type: latestFuture.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS ? glossariActions.REMOVE_GLOSSARY_SUCCESS : glossariActions.ADD_NEW_GLOSSARY_SUCCESS
        }
    }
    const pastWithLatestFuture = [...state.past, latestModFuture];
    const futureWithoutLatest = [...state.future.slice(1)];

    return {
        past: [...pastWithLatestFuture],
        future: [...futureWithoutLatest]
    };
}

export function undoRedoReducer(
    state: StateHistory = initialStateHistory,
    action: UndoRedoActions
): StateHistory {
    switch (action.type) {
        case UndoRedoActionTypes.UNDOSuccess:
            return {
                ...state,
                history: { ...undo(state.history) }
            };

        case UndoRedoActionTypes.REDOSuccess:
            return {
                ...state,
                history: { ...redo(state.history) }
            };
        case UndoRedoActionTypes.CLEANUndo:
            return {
                ...initialStateHistory
            }
        default:
            return state;
    }
}